
import axios from "axios";
import {
  getTokenData,
  getRefreshToken,
  getUserData,
  setTokenData,
} from "./connectStore";
import { getAccessToken } from "../services/authService";

let authTokenRequest;

function getAuthToken() {
  if (!authTokenRequest) {
    authTokenRequest = makeActualAuthenticationRequest();
    authTokenRequest.then(resetAuthTokenRequest, resetAuthTokenRequest);
  }
  return authTokenRequest;
}

function resetAuthTokenRequest() {
  authTokenRequest = null;
}

async function makeActualAuthenticationRequest() {
  try {
    const refresh = getRefreshToken();
    const res = await getAccessToken({ refreshToken: refresh });
    const { accessToken, refreshToken } = res;
    await new Promise((resolve) => setTimeout(resolve, 1000));
    return { accessToken, refreshToken };
  } catch (error) {
    throw new Error("Authentication failed");
  }
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

const needsAuth = (url = "") =>
  url === "profile/updatePassword" ||
  url === "subscription/user" ||
  url === "subscription/createCheckoutSession" ||
  url.startsWith("subscription/") ||
  url.startsWith("subscription/non-renewedSubscription") ||
  url.startsWith("subscription/upcoming-renewals") ||
  url.startsWith("location") ||
  url.startsWith("location/merchant") ||
  url.startsWith("location/status") ||
  url.startsWith("subCategory/create") ||
  url.startsWith("fundraiser/funds") ||
  url.startsWith("payout") ||
  url === "auth/updateReferredBy" ||
  url === "fundraiser/updateContent" ||
  url.startsWith("ruleAndRegulation") ||
  url.startsWith("admin") ||
  url.startsWith("stats") ||
  url === "auth/logout" ||
  url === "notification" ||
  url.startsWith("notification") ||
  url.startsWith("assetAndPromotion") ||
  url.startsWith("offer") ||
  url.startsWith("category") ||
  url.startsWith("merchant/status") ||
  url.startsWith("fundraiser") ||
  url.startsWith("merchant/countOfFavoriteOffers") ||
  url.startsWith("merchant/getAboutPageView") ||
  url.startsWith("merchant/getOfferRedemptionByDemographics") ||
  url.startsWith("offerRedeem") ||
  url.startsWith("merchant") ||
  url.startsWith("promo");
  // url.startsWith("giftCard/purchase");
instance.interceptors.request.use(
  (config) => {
    config.headers["api-key"] = process.env.REACT_APP_API_KEY;
    if (needsAuth(config.url)) {
      const token = getTokenData();
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  undefined,
  (err) => {
    const originalRequest = err?.config;
    const response = err?.response;

    if (response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      return getAuthToken().then((resp) => {
        const userData = getUserData();
        setTokenData({
          ...userData,
          token: resp?.accessToken,
          refreshToken: resp?.refreshToken,
        });

        if (needsAuth(response?.config?.url)) {
          originalRequest.headers.Authorization = `Bearer ${resp?.accessToken}`;
        }

        return instance(originalRequest);
      });
    }

    // Normalize error so callers receive an Error instance with message
    const message =
      response?.data?.message ||
      response?.data?.error ||
      response?.statusText ||
      err?.message ||
      "Request failed";
    const normalized = new Error(message);
    normalized.status = response?.status;
    normalized.data = response?.data;
    normalized.url = response?.config?.url;
    return Promise.reject(normalized);
  }
);

export default instance;
